module.exports = __webpack_public_path__ + "static/media/notebook-danfe.d109198e.png";